import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { storageManager } from '../../core/managers';
import {
  activateChangeProgramCampusModalityUseCase,
  activatePayOrderUseCase,
  activatePaymentCertificateOfStudies,
  activatePaymentReincorporationUseCase,
  activateRegisterCarnetUseCase,
  breadcrumbUseCase,
  cancelChangeProgramCampusModalityUseCase,
  cancelRegisterCarnetUseCase,
  cancelReservationUseCase,
  cancelUpdatePhotoUseCase,
  deleteFileBseUseCase,
  downloadDocumentUseCase,
  filterByWeekUseCase,
  getAcademicCalendarUseCase,
  getAcademicDatesUseCase,
  getAcademicPlanProgress,
  getActivitiesUseCase,
  getBannerList,
  getCampusByModalityUseCase,
  getCampusTabletsUseCase,
  getCoursesWithReinforcements,
  getCoursesGradeRecord,
  getCurrentPeriodUseCase,
  getDatesLibraryUseCase,
  getEventDetail,
  getEventsByStudent,
  getExamsUseCase,
  getFormBse,
  getLinksInterest,
  getModalityOptionListUseCase,
  getPlanProgressDetail,
  getPlanProgressEquivalences,
  getPlanProgressResume,
  getPlanProgressPS,
  getProcedureInformation,
  getProceduresByStudent,
  getProceduresCategoryUseCase,
  getProceduresCreated,
  getProceduresNotAutomatedUseCase,
  getProfessorsUseCase,
  getProfileAdmin,
  getProfilePhotoUseCase,
  getProfileTurnUseCase,
  getProfileUseCase,
  getProfileDataUseCase,
  getProfileMastersDataUseCase,
  getProgramByCampusUseCase,
  getReinforcementDetail,
  getReinforcementUseCase,
  getReinforcementsByCourse,
  getReservationDetailUseCase,
  getScheduleByDay,
  getScheduleOnlyUseCase,
  getScheduleUseCase,
  getScholarshipsDiscounts,
  getAgreementInfo,
  getAgreementValidations,
  getStateBseUseCase,
  getStatusResourceUseCase,
  getStudentInformation,
  getStudentPortalSettingsUseCase,
  getStudentProcedureStatus,
  getStudentSimulated,
  getSubscribedsTabletsUseCase,
  getUrlDocumentUseCase,
  getWeekUseCase,
  getYearsOfProcedures,
  getVersionUseCase,
  modalityOfStudy,
  processFormBse,
  programByCampus,
  registerBseUseCase,
  registerCarnetUseCase,
  registerCertificateOfStudies,
  registerChangeProgramCampusModalityUseCase,
  registerChangeUseCase,
  registerReincorporation,
  registerRemoveFromPeriodUseCase,
  registerTicketNotAutomatedUseCase,
  registerUpdatePhotoUseCase,
  selectAcademicDateUseCase,
  sendValidationCodeUseCase,
  setEventInscription,
  setEventUnsubscribe,
  setSimulator,
  setTutorialUseCase,
  snackbarCase,
  subscribeResourceUseCase,
  subscribeToReinforcement,
  getSurveysValidation,
  registerReinforcementWaitingListUseCase,
  unregisterReinforcementWaitingListUseCase,
  getEnrollmentCourses,
  getRegistrationTimes,
  unsubscribeToReinforcement,
  updateDataProfileUseCase,
  updateProfileUseCase,
  uploadDocumentBse,
  validateUserUseCase,
  getPeriodCourses,
  getSummaryCourses,
  getPeriodsUseCase,
  getEnrolmentApptByPeriodUseCase,
  getStudentType,
  validateCodeByTypeUseCase,
  getLateCourses,
  registerLateCourses,
  activatePaymentLateCourses,
  registerChangePhotoUseCase,
  activateWithdrawalCourse,
  registerWithdrawalCoursesUseCases,
  getEmailAndPhoneUseCase,
  getScheduleResumeHome,
  getPayments,
  getPendingPayments,
  getPaidPayments,
  getPaymentPeriods,
  getPaymentsByPeriod,
  getBenefitInstallments,
  getBenefitInstallmentsInfo,
  activateBenefitInstallments,
  getPaymentBanks,
  getPaymentVouchers,
  generatePaymentVoucher,
  generatePaymentVoucherLateFee,
  createOrder,
  payOrder,
  getCaptcha,
  registerInsuranceValidation,
  getClassAttendanceUseCase,
  getEventsByStudentScroll,
  registerEmployabilityCharter,
  getPeriodsWithDebtsUseCase,
  getEvaluationsToBeCorrected,
  RegisterRectificationOfGrade,
  getProgressiveCertificationEnabled,
  uploadValidation,
  registerWaitingList,
  eventPenalties,
  examsRoleByStudent,
  unregisterWaitingList,
  getUtpAdsDataUseCase,
  getInstitutionalInformation,
  registerAgreement,
  paymentsStatusVerification,
  getProfileAcl,
  getOrganizer
} from '../useCases';

const basePersistConfig = {
  storage: storageManager.create(),
  version: 1,
  blacklist: []
};

const authPersistConfig = {
  ...basePersistConfig,
  key: 'auth',
  blacklist: ['error']
};

/* cuando tenga formulario de inicio de sesion debe llamar al reducer de signIn */
const auth = persistReducer(authPersistConfig, validateUserUseCase.reducer);

const breadcrumb = persistReducer(
  { ...basePersistConfig, key: 'breadcrumb' },
  breadcrumbUseCase.reducer
);

const snackbarBase = persistReducer(
  { ...basePersistConfig, key: 'snackbarBase' },
  snackbarCase.reducer
);

const procedureStudentStatus = persistReducer(
  { ...basePersistConfig, key: 'procedureStudentStatus' },
  getStudentProcedureStatus.reducer
);
const tutorial = persistReducer(
  { ...basePersistConfig, key: 'tutorial' },
  setTutorialUseCase.reducer
);

const profile = persistReducer(
  { ...basePersistConfig, key: 'profile' },
  getProfileUseCase.reducer
);

const profilePhoto = persistReducer(
  {
    ...basePersistConfig,
    key: 'profilePhoto'
  },
  getProfilePhotoUseCase.reducer
);

const simulator = persistReducer(
  { ...basePersistConfig, key: 'simulator' },
  setSimulator.reducer
);

const eventDetail = persistReducer(
  { ...basePersistConfig, key: 'eventDetail' },
  getEventDetail.reducer
);

const externalSettings = persistReducer(
  { ...basePersistConfig, key: 'externalSettings' },
  getStudentPortalSettingsUseCase.reducer
);

const reinforcementDetail = persistReducer(
  { ...basePersistConfig, key: 'reinforcementDetail' },
  getReinforcementDetail.reducer
);

const profileAdmin = persistReducer(
  { ...basePersistConfig, key: 'profileAdmin' },
  getProfileAdmin.reducer
);

const survey = persistReducer(
  { ...basePersistConfig, key: 'survey' },
  getSurveysValidation.reducer
);

const getUrlDocument = persistReducer(
  { ...basePersistConfig, key: 'getUrlDocument' },
  getUrlDocumentUseCase.reducer
);

const getPeriodsPersist = persistReducer(
  {
    ...basePersistConfig,
    key: 'getPeriods'
  },
  getPeriodsUseCase.reducer
);

export default combineReducers({
  academicCalendar: getAcademicCalendarUseCase.reducer,
  academicdates: getAcademicDatesUseCase.reducer,
  academicPlanProgress: getAcademicPlanProgress.reducer,
  activateCarnetUniversity: activateRegisterCarnetUseCase.reducer,
  activateChangeProgramCampusModality:
    activateChangeProgramCampusModalityUseCase.reducer,
  activatePaymentCertificateType01: activatePaymentCertificateOfStudies.reducer,
  activatePaymentReincorporation: activatePaymentReincorporationUseCase.reducer,
  activatePayOrder: activatePayOrderUseCase.reducer,
  activities: getActivitiesUseCase.reducer,
  auth,
  bannerList: getBannerList.reducer,
  breadcrumb,
  cancelChangeProgramCampusModality:
    cancelChangeProgramCampusModalityUseCase.reducer,
  cancelRegisterCarnet: cancelRegisterCarnetUseCase.reducer,
  cancelReservation: cancelReservationUseCase.reducer,
  cancelUpdatePhoto: cancelUpdatePhotoUseCase.reducer,
  coursesWithReinforcements: getCoursesWithReinforcements.reducer,
  currentPeriod: getCurrentPeriodUseCase.reducer,
  deleteFileBse: deleteFileBseUseCase.reducer,
  downloadDocument: downloadDocumentUseCase.reducer,
  eventDetail,
  events: getEventsByStudent.reducer,
  exams: getExamsUseCase.reducer,
  externalSettings,
  filterByWeek: filterByWeekUseCase.reducer,
  getCampusByModality: getCampusByModalityUseCase.reducer,
  getCampusTablets: getCampusTabletsUseCase.reducer,
  getCoursesGradeRecord: getCoursesGradeRecord.reducer,
  getDatesLibrary: getDatesLibraryUseCase.reducer,
  getFormBse: getFormBse.reducer,
  getPlanProgressDetail: getPlanProgressDetail.reducer,
  getPlanProgressEquivalences: getPlanProgressEquivalences.reducer,
  getPlanProgressResume: getPlanProgressResume.reducer,
  getPlanProgressPS: getPlanProgressPS.reducer,
  getPeriodCourses: getPeriodCourses.reducer,
  getProceduresCreated: getProceduresCreated.reducer,
  getProgramByCampus: getProgramByCampusUseCase.reducer,
  getReinforcementsByCourse: getReinforcementsByCourse.reducer,
  getReservationDetail: getReservationDetailUseCase.reducer,
  getStateBse: getStateBseUseCase.reducer,
  getStatusResource: getStatusResourceUseCase.reducer,
  getSubscribedsTablets: getSubscribedsTabletsUseCase.reducer,
  getSummaryCourses: getSummaryCourses.reducer,
  getUrlDocument,
  getVersion: getVersionUseCase.reducer,
  interestLinks: getLinksInterest.reducer,
  modalityOfStudy: modalityOfStudy.reducer,
  modalityOptionList: getModalityOptionListUseCase.reducer,
  procedureInformation: getProcedureInformation.reducer,
  proceduresByCategory: getProceduresCategoryUseCase.reducer,
  proceduresByStudent: getProceduresByStudent.reducer,
  proceduresNotAutomated: getProceduresNotAutomatedUseCase.reducer,
  procedureStudentStatus,
  processBse: processFormBse.reducer,
  professor: getProfessorsUseCase.reducer,
  profile,
  profileAdmin,
  profilePhoto,
  profileTurn: getProfileTurnUseCase.reducer,
  programByCampus: programByCampus.reducer,
  registerBse: registerBseUseCase.reducer,
  registerCarnet: registerCarnetUseCase.reducer,
  registerCertificateType01: registerCertificateOfStudies.reducer,
  registerChange: registerChangeUseCase.reducer,
  registerChangeProgramCampusModality:
    registerChangeProgramCampusModalityUseCase.reducer,
  registerReincorporation: registerReincorporation.reducer,
  registerRetirementOfPeriod: registerRemoveFromPeriodUseCase.reducer,
  registerTicket: registerTicketNotAutomatedUseCase.reducer,
  registerUpdatePhoto: registerUpdatePhotoUseCase.reducer,
  registerLateCourses: registerLateCourses.reducer,
  activatePaymentLateCourses: activatePaymentLateCourses.reducer,
  reinforcementDetail,
  reinforcements: getReinforcementUseCase.reducer,
  schedule: getScheduleUseCase.reducer,
  scheduleHome: getScheduleByDay.reducer,
  scheduleOnly: getScheduleOnlyUseCase.reducer,
  selectAcademicDate: selectAcademicDateUseCase.reducer,
  sendValidationCode: sendValidationCodeUseCase.reducer,
  setEventInscription: setEventInscription.reducer,
  setEventUnsubscribe: setEventUnsubscribe.reducer,
  simulator,
  snackbarBase,
  studentInformation: getStudentInformation.reducer,
  studentSimulated: getStudentSimulated.reducer,
  subscribeResource: subscribeResourceUseCase.reducer,
  subscribeToReinforcement: subscribeToReinforcement.reducer,
  survey,
  EnrolmentCourses: getEnrollmentCourses.reducer,
  registrationTimes: getRegistrationTimes.reducer,
  tutorial,
  unsubscribeToReinforcement: unsubscribeToReinforcement.reducer,
  registerReinforcementWaitingList:
    registerReinforcementWaitingListUseCase.reducer,
  unregisterReinforcementWaitingList:
    unregisterReinforcementWaitingListUseCase.reducer,
  updateDataProfile: updateDataProfileUseCase.reducer,
  updateProfile: updateProfileUseCase.reducer,
  uploadDocumentBse: uploadDocumentBse.reducer,
  week: getWeekUseCase.reducer,
  yearsOfProcedures: getYearsOfProcedures.reducer,
  getPeriods: getPeriodsPersist,
  getEnrolmentAppByPeriod: getEnrolmentApptByPeriodUseCase.reducer,
  validateCodeByType: validateCodeByTypeUseCase.reducer,
  getLateCourses: getLateCourses.reducer,
  registerChangePhoto: registerChangePhotoUseCase.reducer,
  activateWithdrawalCourse: activateWithdrawalCourse.reducer,
  registerWithdrawalCourses: registerWithdrawalCoursesUseCases.reducer,
  getEmailAndPhone: getEmailAndPhoneUseCase.reducer,
  getProfileData: getProfileDataUseCase.reducer,
  getProfileMastersData: getProfileMastersDataUseCase.reducer,
  getStudentType: getStudentType.reducer,
  getScheduleResumeHome: getScheduleResumeHome.reducer,
  getPayments: getPayments.reducer,
  getPendingPayments: getPendingPayments.reducer,
  getPaidPayments: getPaidPayments.reducer,
  getPaymentPeriods: getPaymentPeriods.reducer,
  getPaymentsByPeriod: getPaymentsByPeriod.reducer,
  getBenefitInstallments: getBenefitInstallments.reducer,
  getBenefitInstallmentsInfo: getBenefitInstallmentsInfo.reducer,
  activateBenefitInstallments: activateBenefitInstallments.reducer,
  getPaymentBanks: getPaymentBanks.reducer,
  getPaymentVouchers: getPaymentVouchers.reducer,
  generatePaymentVoucher: generatePaymentVoucher.reducer,
  generatePaymentVoucherLateFee: generatePaymentVoucherLateFee.reducer,
  createOrder: createOrder.reducer,
  payOrder: payOrder.reducer,
  getCaptcha: getCaptcha.reducer,
  registerInsuranceValidation: registerInsuranceValidation.reducer,
  classAttendance: getClassAttendanceUseCase.reducer,
  getEventsByStudentScroll: getEventsByStudentScroll.reducer,
  registerEmployabilityCharter: registerEmployabilityCharter.reducer,
  getPeriodsWithDebtsUseCase: getPeriodsWithDebtsUseCase.reducer,
  getEvaluationsToBeCorrected: getEvaluationsToBeCorrected.reducer,
  RegisterRectificationOfGrade: RegisterRectificationOfGrade.reducer,
  getProgressiveCertificationEnabled:
    getProgressiveCertificationEnabled.reducer,
  uploadValidation: uploadValidation.reducer,
  registerWaitingList: registerWaitingList.reducer,
  eventPenalties: eventPenalties.reducer,
  examsRoleByStudent: examsRoleByStudent.reducer,
  unregisterWaitingList: unregisterWaitingList.reducer,
  getUtpAdsData: getUtpAdsDataUseCase.reducer,
  getInstitutionalInformation: getInstitutionalInformation.reducer,
  getAgreementInfo: getAgreementInfo.reducer,
  getAgreementValidations: getAgreementValidations.reducer,
  getScholarshipsDiscounts: getScholarshipsDiscounts.reducer,
  registerAgreement: registerAgreement.reducer,
  paymentsStatusVerification: paymentsStatusVerification.reducer,
  getProfileAcl: getProfileAcl.reducer,
  getOrganizer: getOrganizer.reducer
});
